import { render, staticRenderFns } from "./button.vue?vue&type=template&id=cf6835ea&scoped=true"
import script from "./button.vue?vue&type=script&lang=ts"
export * from "./button.vue?vue&type=script&lang=ts"
import style0 from "./button.vue?vue&type=style&index=0&id=cf6835ea&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6835ea",
  null
  
)

export default component.exports